export const SERVICES = [
  {
    key: "web",
    title: "Website Development",
    short: "Business websites, WordPress builds, and ecommerce-ready sites designed for conversions and long-term SEO.",
    bullets: ["Mobile-first responsive design", "Core Web Vitals performance", "WordPress and custom builds", "SEO-friendly page structure"],
    group: "Build",
  },
  {
    key: "woo",
    title: "WooCommerce Development",
    short: "Ecommerce websites built on WooCommerce with payments, catalog management, and checkout optimization.",
    bullets: ["WooCommerce store setup", "Razorpay & Stripe integration", "Inventory & logistics sync", "Conversion-optimized checkout"],
    group: "Build",
  },
  {
    key: "landing",
    title: "High-Converting Landing Pages",
    short: "Campaign pages built around one job: turn visitors into leads for sales, service, and growth campaigns.",
    bullets: ["A/B testing variants", "Heatmap analytics", "Form-to-CRM integration", "Lead capture optimization"],
    group: "Build",
  },
  {
    key: "seo",
    title: "SEO Services",
    short: "Technical, content and local SEO for sustainable organic visibility and search performance.",
    bullets: ["Site audits & analysis", "Schema & Core Web Vitals", "Editorial backlink strategy", "Keyword research & optimization"],
    group: "Grow",
  },
  {
    key: "localseo",
    title: "Local SEO & Google Business",
    short: "Rank in local search results and map packs with optimized Google Business profiles and local SEO strategies.",
    bullets: ["Google Business Profile optimization", "Local review management", "Map pack ranking", "Location-based keywords"],
    group: "Grow",
  },
  {
    key: "leads",
    title: "Lead Generation Systems",
    short: "Integrated systems combining paid ads, landing pages, and lead magnets for consistent lead flow.",
    bullets: ["Meta & Google Ads", "Landing page funnels", "Lead magnet strategy", "CRM lead routing"],
    group: "Grow",
  },
  {
    key: "email",
    title: "Email Marketing",
    short: "Automated email sequences that nurture leads and drive repeat customer engagement.",
    bullets: ["Lifecycle automation", "Segmentation strategies", "Deliverability optimization", "A/B testing"],
    group: "Automate",
  },
  {
    key: "whatsapp",
    title: "WhatsApp Automation",
    short: "WhatsApp API automation for customer support, lead qualification, and follow-up at scale.",
    bullets: ["Official WhatsApp API", "Chatbot flows", "Lead qualification routing", "Customer support automation"],
    group: "Automate",
  },
  {
    key: "crm",
    title: "CRM Setup",
    short: "Complete CRM implementation with pipeline design, automation, and team training.",
    bullets: ["Custom pipelines & stages", "Sales process automation", "Team training & onboarding", "Integrations"],
    group: "Automate",
  },
  {
    key: "ai",
    title: "AI Workflows",
    short: "AI automation workflows and GPT-powered tools for support, research, and operational efficiency.",
    bullets: ["Custom GPT agents", "Document RAG systems", "Voice & chat automation", "Human-in-the-loop review"],
    group: "Automate",
  },
  {
    key: "n8n",
    title: "n8n Automation",
    short: "Self-hosted workflows that connect business tools, automate tasks, and reduce manual handoffs.",
    bullets: ["200+ integrations", "Cron & webhook triggers", "Error handling & recovery", "Monitoring dashboards"],
    group: "Automate",
  },
  {
    key: "make",
    title: "Make.com Automation",
    short: "Visual automation flows for marketing, finance, and operations teams.",
    bullets: ["Multi-step workflows", "Error recovery & retries", "Cost-optimized automation", "Reusable templates"],
    group: "Automate",
  },
  {
    key: "bpa",
    title: "Business Automation",
    short: "Automate operations, workflows, and customer touchpoints to reduce manual work and improve consistency.",
    bullets: ["Process audit & mapping", "SOP design & documentation", "Tool selection & implementation", "Team enablement"],
    group: "Automate",
  },
];

export const INDUSTRIES = [
  "D2C & Ecommerce",
  "Real Estate",
  "Healthcare & Clinics",
  "Education & EdTech",
  "Manufacturing",
  "Hospitality",
  "Professional Services",
  "Logistics",
];

export const CASE_STUDIES = [];

export const TESTIMONIALS = [];

export const FAQS = [
  {
    q: "Are you a full-service agency or specialists?",
    a: "Both. CyberCart is a single technology partner — we cover websites, SEO, lead generation, CRM, AI and automation under one roof, with specialists in each function.",
  },
  {
    q: "Do you work with businesses outside Mumbai?",
    a: "Yes. We're based in Mumbai and serve clients across India and abroad. For local SEO and field operations, our Mumbai presence is a strong advantage.",
  },
  {
    q: "How quickly can we get started?",
    a: "Most engagements kick off within 5–7 working days of a signed proposal. For urgent campaign launches we can compress this further.",
  },
  {
    q: "What does a typical engagement look like?",
    a: "We start with a discovery sprint, then build, automate and grow in phases. You get a dedicated project lead, weekly updates and a shared dashboard.",
  },
  {
    q: "How is pricing structured?",
    a: "We price per project for builds (websites, automations) and on monthly retainers for growth (SEO, lead gen, CRM ops). Every quote is fixed and transparent.",
  },
  {
    q: "Will I own the systems you build?",
    a: "Absolutely. Code, accounts, automations and data — all are handed over to you. We're a partner, never a lock-in.",
  },
];

export const STATS = [];
